import {Card} from 'antd';
import {PropertyList} from 'components';
import React from 'react';
import {SectionProps} from '../utils/types';
import {formatAddress} from 'lib/formaters';

export const BusinessDetails: React.FC<SectionProps> = ({cardProps, affiliate, payoutMethod}) => {
  if (!affiliate || !affiliate.company)
    return (
      <Card {...cardProps} title="Business details">
        <PropertyList omitEmpty properties={[]} />
      </Card>
    );

  const affiliateAddress = {
    line1: affiliate.address?.address,
    line2: '',
    city: affiliate.address?.city,
    country: affiliate.address?.country?.code,
    state: affiliate.address?.state,
    zip: affiliate.address?.postal_code
  };

  return (
    <>
      <Card {...cardProps} title="Business details">
        <PropertyList
          omitEmpty
          properties={[
            {
              label: 'Country',
              value: affiliate.address?.country?.name
            },
            {
              label: 'Name',
              value: affiliate.company?.name
            },
            {
              label: 'Address',
              value: formatAddress(affiliateAddress)
            },
            {
              label: 'NIF',
              copyable: {text: payoutMethod?.details?.nif!},
              value: payoutMethod?.details?.nif
            }
          ]}
        />
      </Card>
    </>
  );
};
